<form [formGroup]="form" autocomplete="off" novalidate>
  <app-status-bar
    [validities]="validities"
    [myform]="form?.value"
  ></app-status-bar>

  <app-angaben-zur-person appReadonlyBehaviour
    formControlName="angabenZurPerson"
  ></app-angaben-zur-person>

  <app-kontaktdaten appReadonlyBehaviour
    formControlName="kontaktdaten"
  ></app-kontaktdaten>

  <app-ausweispapiere appReadonlyBehaviour
    formControlName="ausweispapiere"
  ></app-ausweispapiere>

  <app-reisedaten appReadonlyBehaviour
    *ngIf="appConfig.isReisedatenActive"
    formControlName="reisedaten"
  ></app-reisedaten>

  <app-reisedaten-kurzfristiger-aufenthalt appReadonlyBehaviour
    *ngIf="appConfig.isReisedatenKurzfristigerAufenthaltActive"
    formControlName="reisedaten"
  ></app-reisedaten-kurzfristiger-aufenthalt>

  <app-referenz appReadonlyBehaviour
    [hidden]="form.controls.referenz.disabled"
    formControlName="referenz"
  ></app-referenz>

  <app-lebensunterhalt-aufenthaltsdetails appReadonlyBehaviour
    *ngIf="appConfig.isLebensunterhaltAufenthaltsdetailsActive"
    formControlName="lebensunterhaltAufenthaltsdetails"
  ></app-lebensunterhalt-aufenthaltsdetails>

  <app-kostenuebernahme appReadonlyBehaviour
    [hidden]="form.controls.kostenuebernahme.disabled"
    formControlName="kostenuebernahme"
  ></app-kostenuebernahme>

  <app-zusaetzliche-angaben
    *ngIf="appConfig.isZusaetzlicheAngabenActive"
    formControlName="zusaetzlicheAngaben"
    [referenzArt]="form.value.referenz?.art"
    [rechtAufFreizuegigkeit]="form.value.angabenZurPerson?.isRechtAufFreizuegigkeit"
  ></app-zusaetzliche-angaben>

  <app-dokumente
    *ngIf="isDokumenteActive"
    formControlName="dokumente"
    [hasErwerbstaetigkeit]="isErwerbstaetigkeit"
    [bereitsVorhandeneDokumente]="form.value.dokumente?.bereitsVorhandeneDokumente">
  </app-dokumente>

  <app-lichtbild
    formControlName="lichtbild"
    *ngIf="isLichtbildActive"
  ></app-lichtbild>

  <app-fingerabdruck
    formControlName="fingerabdruck"
    *ngIf="isFingerabdruckActive"
    [antragstellerGeschlecht]="form.value.angabenZurPerson && form.value.angabenZurPerson.geschlecht"
    [antragstellerAlter]="form.value.angabenZurPerson && form.value.angabenZurPerson.alter"
    [antragstellerGeburtsdatum]="form.value.angabenZurPerson && form.value.angabenZurPerson.geburtsdatum"
  ></app-fingerabdruck>


</form>
